import { IFacility } from '../models/facility';

export interface IAppState {
  root?: any
  facilities?: Array<IFacility>
}

var initialState: IAppState = {
  facilities: [],
};

const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'facility/loaded':
      return Object.assign({}, state, {
        facilities: action.facilities
      });
  }
  return state;
};

export default rootReducer;
